module.exports = __webpack_public_path__ + "static/media/student-snapshort2-ploblem.2a871c51.png";